import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { airForm } from '../../../commonComponents';

import CustomServices from './CustomServices';

import { Form, Layout, Row } from 'antd';
import { ServiceTypeDivider } from './ServiceTypeDivider/ServiceTypeDivider';
import VehicleServices from './VehicleServices';

const { Content } = Layout;

@inject('translationsStore', 'step3RegistrationStore', 'registrationStore')
@observer
class AlarmsTabPane extends Component {
  componentDidMount() {
    this.setFieldsValue();
  }

  setFieldsValue() {
    this.props.form.setFieldsValue(this.props.step3RegistrationStore.formValues.maintenances);
  }

  //servicing events handlers
  onClickServicingHandler = checkedValues => {
    this.props.step3RegistrationStore.setFormField('maintenances.servicing.checked', checkedValues);
    this.setFieldsValue();
  };

  showCustomService = showCustomService => {
    this.props.step3RegistrationStore.setFormField('maintenances.customServices.checked', showCustomService);
    this.setFieldsValue();
  };

  render() {
    const {
      step3RegistrationStore,
      registrationStore,
      translationsStore: { current: t }
    } = this.props;
    const { checked: servicingChecked } = step3RegistrationStore.formValues.maintenances.servicing;
    const { checked: customServicesChecked } = step3RegistrationStore.formValues.maintenances.customServices;

    return (
      <Form name="product" onSubmit={this.onSubmitHandler}>
        <Layout>
          <Content>
            <Row className="cardata" style={{ paddingBottom: '30px' }}>
              <Row>
                <strong>{t['shared']['lblModel']}:&nbsp;</strong>
                {registrationStore.car.make.descrizione || registrationStore.car.make.codiceMarca || registrationStore.car.make}&nbsp;
                {registrationStore.car.model.descrizione || registrationStore.car.model.codiceModello || registrationStore.car.make}&nbsp;
                {registrationStore.car.type.descrizione || registrationStore.car.type.codiceInfocarAM || registrationStore.car.make}
              </Row>

              <Row>
                <strong>{t['shared']['lblCarRegistration']}:&nbsp;</strong>
                {registrationStore.car.matriculationYear}&nbsp;
              </Row>
              <Row>
                <strong>{t['shared']['lblPower']}:&nbsp;</strong>
                {registrationStore.car.alimentation}&nbsp;
              </Row>
              <Row>
                <strong>{t['shared']['lblDisplacement']}:&nbsp;</strong>
                {registrationStore.car.displacement}&nbsp;
              </Row>
            </Row>
            <ServiceTypeDivider
              disabled={!step3RegistrationStore.servicing.isServicingCheckBoxEnabled || step3RegistrationStore.inProgress}
              label={t['registration_3']['maintenances']['service']['label']}
              onChange={this.onClickServicingHandler}
              checked={servicingChecked}
            />

            <VehicleServices disabled={!servicingChecked || step3RegistrationStore.inProgress} />

            <ServiceTypeDivider label={t['registration_3']['maintenances']['other']['label']} onChange={this.showCustomService} checked={customServicesChecked} />

            <CustomServices disabled={!customServicesChecked} />
          </Content>
        </Layout>
      </Form>
    );
  }
}

export default Form.create()(airForm(AlarmsTabPane));



// WEBPACK FOOTER //
// ./src/components/RegistrationSteps/Step_3/AlarmsTabPane.js